import { Button, Form } from 'antd'
import { FolderOpen } from 'lucide-react'
import type { OrderGroup } from '@super-mega/server/contracts/order'

export function OrderGroupSelectionField({
  customerId,
  disabled,
  orderGroup,
  onSelect,
  onClear
}: {
  customerId?: number
  disabled: boolean
  orderGroup?: OrderGroup
  onSelect: () => void
  onClear: () => void
}) {
  return (
    <Form.Item extra="只能选择当前客户已有的订单组。" htmlFor="orderGroupId" label="已有订单组" required>
      <div className="flex gap-2">
        <Form.Item name="orderGroupId" noStyle rules={[{ required: true, message: '请选择已有订单组' }]}>
          <Button
            className="min-w-0 flex-1"
            disabled={disabled || !customerId}
            icon={<FolderOpen aria-hidden size={16} />}
            onClick={onSelect}
          >
            {orderGroup?.name ?? (customerId ? '点击选择订单组' : '请先选择客户')}
          </Button>
        </Form.Item>
        {orderGroup ? (
          <Button disabled={disabled} onClick={onClear}>
            移出订单组
          </Button>
        ) : null}
      </div>
    </Form.Item>
  )
}
